module.exports = __webpack_public_path__ + "static/img/weather67.76447e81.png";